import React from 'react';
import UserProfileWidget from './community/UserProfileWidget';
import ProfileEfficacyWidget from './community/ProfileEfficacyWidget';
import AIProfileSuggestionsWidget from './community/AIProfileSuggestionsWidget';
import ConnectionsStatsWidget from './community/ConnectionsStatsWidget';
import MatchConnectWidget from './community/MatchConnectWidget';
import GroupFeedWidget from './community/GroupFeedWidget';
import BestMatchesWidget from './connections/BestMatchesWidget';
// Import the connections data from ConnectionsList
const connectionsData = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'Data Scientist @ Intel',
  location: 'Milano, Italia',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 95,
  tags: ['AI', 'Machine Learning', 'ESG'],
  matchReason: 'Avete partecipato agli stessi 3 corsi e condividete interessi in AI e sostenibilità',
  connectionType: 'both',
  isConnected: true
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'ML Engineer @ Google',
  location: 'Roma, Italia',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 88,
  tags: ['Deep Learning', 'Computer Vision', 'Sostenibilità'],
  matchReason: 'Competenze complementari in Deep Learning e Computer Vision. Entrambi interessati a progetti di sostenibilità',
  connectionType: 'course',
  isConnected: true
}
// ... rest of the connections data
];
const CommunityDashboard = () => {
  return <div className="space-y-4" data-id="element-647">
      {/* First row - Profile widgets */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-648">
        <div className="col-span-1" data-id="element-649">
          <UserProfileWidget data-id="element-650" />
        </div>
        <div className="col-span-1" data-id="element-651">
          <ProfileEfficacyWidget data-id="element-652" />
        </div>
        <div className="col-span-1" data-id="element-653">
          <AIProfileSuggestionsWidget data-id="element-654" />
        </div>
      </div>
      {/* Second row - KPI widgets */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-655">
        <ConnectionsStatsWidget title="Connessioni" value="127" trend="+12 questo mese" icon="users" data-id="element-656" />
        <ConnectionsStatsWidget title="Indice di Impatto" value="92%" trend="Top 5% nella community" icon="groups" data-id="element-657" />
        <ConnectionsStatsWidget title="Efficacia Profilo" value="87%" trend="+15% rispetto al benchmark" icon="chart" data-id="element-658" />
      </div>
      {/* Third row - Match & Feed widgets */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-659">
        <div className="col-span-1" data-id="element-660">
          <MatchConnectWidget data-id="element-661" />
        </div>
        <div className="col-span-1" data-id="element-662">
          <GroupFeedWidget data-id="element-663" />
        </div>
      </div>
    </div>;
};
export default CommunityDashboard;